import React from 'react'
import Card from "react-bootstrap/Card";
import uuid from 'react-uuid'

import Loader from "../loader/Loader";

interface CardCustomInterface {
    isLoading?: boolean,
    isError?: boolean|Object,
    key?: string|number,
    cardClassName: string,
    header: Node|string,
    headerClassName: string,
    body: Node|string|Function,
    bodyClassName?: string,
    footer: Node|string|Function,
    footerClassName?: string,
}
const CardCustom = ({
    isLoading = false,
    isError = false,
    key,
    cardClassName,
    header,
    headerClassName,
    body,
    bodyClassName,
    footer,
    footerClassName,
}: CardCustomInterface) => {
    return (
        <>
            {!isLoading && !isError && (
                <Card key={key || uuid()} className={cardClassName}>
                    <div className={`card-horizontal`}>
                        <Card.Header className={headerClassName}>
                            {header}
                        </Card.Header>
                        <Card.Body className={bodyClassName}>
                            {((typeof body === typeof (()=>{})) ? body() : body)}
                        </Card.Body>
                    </div>
                    <Card.Footer className={footerClassName}>
                        {((typeof body === typeof (()=>{})) ? footer() : footer)}
                    </Card.Footer>
                </Card>
            )}

            {isLoading && <Loader/>}
        </>
    )
}

export default CardCustom
